import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";

  var INTEGRATION_CONTEXT = {
    sessionCam: 'sessionCamRecorder',
    quantumMetrics: 'QuantumMetricAPI',
  };

  function getParameterBySource(getParamsBySourceParameters) {
    switch (getParamsBySourceParameters.source) {
      case 'var':
        return KAMPYLE_UTILS.getNestedPropertyValue(window, getParamsBySourceParameters.param);
      case 'cookie':
        return KAMPYLE_UTILS.kampyleGetCookie(getParamsBySourceParameters.param);
      case 'function':
        var func = KAMPYLE_UTILS.getNestedPropertyValue(window, getParamsBySourceParameters.param);
        if (typeof func === 'function') {
          try {
            var predefinedArgs = getParamsBySourceParameters.predefinedArgs;
            if (predefinedArgs) {
                predefinedArgs = predefinedArgs.split(',');
                return (predefinedArgs instanceof Array) ? func.apply(getParamsBySourceParameters.context, predefinedArgs) : null;
            }
            else {
                return func.apply(getParamsBySourceParameters.context);
            }
          }
          catch (e) {
            return null;
          }
        }
        else {
          return null;
        }
      case 'url':
        return KAMPYLE_UTILS.getUrlParam(KAMPYLE_UTILS.getNestedPropertyValue(window, getParamsBySourceParameters.param));
      case 'storage':
        return localStorage.getItem(KAMPYLE_UTILS.getNestedPropertyValue(window, getParamsBySourceParameters.param));
      default:
    }
  }

  function isEnabled(integrationData) {
    var isEnabledBol = true;
    var valueBySource;
    var paramValue;
    var isEnabledArray = integrationData.isEnabled;
    var contextParam = INTEGRATION_CONTEXT[integrationData.integrationName];
    var integrationContext = KAMPYLE_UTILS.getNestedPropertyValue(window, contextParam);
    for (var i = 0; i < isEnabledArray.length; i++) {
      var isEnabledCurr = false;
      var isEnabledCurrName = isEnabledArray[i].param;
      paramValue = isEnabledArray[i].paramValue;
      if (!isEnabledCurrName) {
        KAMPYLE_UTILS.showWarning('no current name found');
      }
      valueBySource = getParameterBySource({source : isEnabledArray[i].source,param : isEnabledCurrName,context : integrationContext,predefinedArgs : isEnabledArray[i].predefinedArguments});
      if (paramValue === null) {  //meaning just need to have value
        isEnabledCurr = (valueBySource !== undefined && valueBySource !== null);
      }
      else {
        isEnabledCurr = paramValue === valueBySource;
      }

      isEnabledBol = isEnabledBol && isEnabledCurr;
    }
    return isEnabledBol;
  }

  function prepareIntegrationData(integrationData) {
    var parametersJson = {};
    var integrationDataJson = {};
    var parametersArray = integrationData.parameters || [];
    var contextParam = INTEGRATION_CONTEXT[integrationData.integrationName] || null;
    var integrationContext = KAMPYLE_UTILS.getNestedPropertyValue(window, contextParam);

    for (var i = 0; i < parametersArray.length; i++) {
      var paramValue = getParameterBySource({source: parametersArray[i].source,param : parametersArray[i].param,context : integrationContext,predefinedArgs : parametersArray[i].predefinedArguments});
      var putIn = integrationData.parameters[i].putIn;
      KAMPYLE_UTILS.setNestedPropertyValue(parametersJson, putIn, paramValue);
    }

    integrationDataJson = {
      integrationName: integrationData.integrationName,
      parameters: parametersJson,
    };

    return integrationDataJson;
  }

  function getIntegrationData(integrationName) {
    var integrations = KAMPYLE_DATA.getInegrations() || {};
    var integrationData = {};
    var currIntegration;
    for (var integrationType in integrations) {
      if (integrations.hasOwnProperty(integrationType)) {
        var currIntegrationTypeList = integrations[integrationType] || [];
        for (var i = 0; i < currIntegrationTypeList.length; i++) {
          currIntegration = currIntegrationTypeList[i];
          if (isEnabled(currIntegration)) {
            if (integrationName) {
              if (currIntegration.integrationName === integrationName) {
                integrationData[integrationType] = [prepareIntegrationData(currIntegration)]
                return integrationData;
              }
            } else {
              integrationData[integrationType] = integrationData[integrationType] || [];
              integrationData[integrationType].push(prepareIntegrationData(currIntegration));
            }
          }
        }
      }
    }
    return integrationData;
  }

  export default {
    // for testing
    isEnabled: isEnabled,
    prepareIntegrationData: prepareIntegrationData,
    // Public API
    getIntegrationData: getIntegrationData,
    getParameterBySource: getParameterBySource,
  };
